module.exports = __webpack_public_path__ + "static/media/criteria-8.2.1863ba7a.jpg";